import { Link } from "react-router-dom";

export default function FeaturedBanner() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16">
      <div className="relative w-full rounded-2xl overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=warm%20community%20gathering%20flat%20lay%20with%20books%20camera%20and%20coffee%20mugs%2C%20amber%20and%20cream%20tones%2C%20soft%20natural%20light%2C%20minimal%20clean%20aesthetic%2C%20editorial%20photography&width=1600&height=640&seq=banana-feature-banner&orientation=landscape"
          alt="香蕉社区专题活动"
          title="香蕉社区专题推荐活动"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/65 to-foreground-950/35" />
        <div className="relative z-10 px-6 md:px-12 py-12 md:py-16 max-w-2xl">
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-foreground-950 text-xs font-medium mb-5">
            <i className="ri-megaphone-line" />
            十月专题活动
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 leading-tight text-balance">
            晒出你的生活切片，赢取社区专属徽章
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-100/90 leading-relaxed">
            本月主题是「我的一平米幸福」。无论是清晨的一杯咖啡，还是窗边悄悄抽芽的绿植，都可以成为你分享的理由。参与即有机会获得社区限定徽章与精选推荐位。
          </p>
          <div className="mt-8 flex items-center gap-3 flex-col sm:flex-row">
            <Link
              to="/post"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-edit-2-line" />
              立即参与活动
            </Link>
            <Link
              to="/category/life"
              className="inline-flex items-center gap-2 h-12 px-6 rounded-full bg-background-50/15 hover:bg-background-50/25 border border-background-50/40 text-background-50 font-medium backdrop-blur-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              看看大家怎么说
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}